const ESTADOS_EXPEDIENTE = [
  {
    valor: 'SIN_EXPEDIENTE',
    nombre: 'Sin Expediente',
    color: 'grey lighten-1',
    dark: false,
  },
  {
    valor: 'SIN_DOCUMENTOS_APLICABLES',
    nombre: 'Sin Documentos Aplicables',
    color: 'grey darken-1',
    dark: true,
  },
  {
    valor: 'CRITICO',
    nombre: 'Crítico',
    color: 'red darken-2',
    dark: true,
  },
  {
    valor: 'EN_PROCESO',
    nombre: 'En Proceso',
    color: 'amber darken-2',
    dark: false,
  },
  {
    valor: 'AVANZADO',
    nombre: 'Avanzado',
    color: 'blue',
    dark: true,
  },
  {
    valor: 'COMPLETO',
    nombre: 'Completo',
    color: 'success',
    dark: false,
  },
];

const ESTADO_DESCONOCIDO = {
  valor: null,
  nombre: 'Desconocido',
  color: 'grey',
  dark: false,
};

const obtenerEstado = (valor) => ESTADOS_EXPEDIENTE.find(
  (estado) => estado.valor === valor,
) || { ...ESTADO_DESCONOCIDO, valor };

const NOMBRES_SEMAFORO = {
  VERDE: 'Verde',
  AZUL: 'Azul',
  AMARILLO: 'Amarillo',
  ROJO: 'Rojo',
  GRIS: 'Gris',
};

const obtenerNombreSemaforo = (semaforo) => NOMBRES_SEMAFORO[semaforo] || semaforo;

export {
  ESTADOS_EXPEDIENTE, obtenerEstado, NOMBRES_SEMAFORO, obtenerNombreSemaforo,
};
